import { Box } from '@mui/material';
import { useListContext, useTranslate } from 'react-admin';
import { AnalyticsChartTitle } from '@/components/analytics/common/AnalyticsChartTitle.jsx';
import { ProductAnalyticsInfo } from '@/components/analytics/product/ProductAnalyticsInfo.jsx';
import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const TransactionInvalidContainersAnalytics = () => {
    const { data } = useListContext();
    const translate = useTranslate();

    if (!data || data.length === 0) return null;
    const analytic = data[0].data;
    const previous = data[1].data;

    const errors = [
        ['not_validated', analytic.transactionsNotValidatedContainersCount],
        ['weight_invalid', analytic.transactionsWeightInvalidContainersCount],
        ['weight_max_invalid', analytic.transactionsWeightMaxInvalidContainersCount],
        ['weight_min_invalid', analytic.transactionsWeightMinInvalidContainersCount],
        ['height_invalid', analytic.transactionsHeightInvalidContainersCount],
        ['width_invalid', analytic.transactionsWidthInvalidContainersCount],
        ['material_invalid', analytic.transactionsMaterialInvalidContainersCount],
        ['z_sensor_invalid', analytic.transactionsZSensorInvalidContainersCount],
        ['rot_angle_invalid', analytic.transactionsRotAngleInvalidContainersCount],
        ['removed_after_scan', analytic.transactionsRemovedAfterScanContainersCount],
        ['detection_invalid', analytic.transactionsDetectionInvalidContainersCount],
        ['dropped_after_invalid', analytic.transactionsDroppedAfterInvalidContainersCount],
        ['general_fail', analytic.transactionsGeneralFailContainersCount],
        ['color_invalid', analytic.transactionsColorInvalidContainersCount],
        ['removed_from_bin', analytic.transactionsRemovedFromBinContainersCount],
        ['no_deposit', analytic.transactionsNoDepositContainersCount],
    ].sort(([, a], [, b]) => b - a);

    const growth =
        ((analytic.transactionsInvalidContainersCount - previous.transactionsInvalidContainersCount) / previous.transactionsInvalidContainersCount) * 100;

    return (
        <Box
            sx={{
                backgroundColor: Palette.white,
                width: '100%',
                padding: '40px 40px 48px',
                borderRadius: '16px',
                [`@media (max-width: ${breakpoints.values.md}px)`]: {
                    padding: '24px',
                },
            }}
        >
            <AnalyticsChartTitle
                title={translate('analytics.transaction.invalidContainers')}
                value={analytic.transactionsInvalidContainersCount}
                growth={growth}
                hideNoDataPlaceholder={true}
            />
            <Box sx={{ marginTop: '26px' }}>
                {errors.map(([code, value]) => (
                    <ProductAnalyticsInfo key={code} code={code} validateCode={true} value={value} total={analytic.transactionsInvalidContainersCount} />
                ))}
            </Box>
        </Box>
    );
};
